export default __webpack_public_path__ + "static/media/UCLAMAP.02e231e5.png";